import { useState, useEffect, useContext } from "react";
import { notify } from "../utils/utils";
import { AuthFetch,Fetch } from "../services/api";
import { useModal } from './useModal';
import { useSpinner } from "./useSpinner";
import { UserContext } from "../context/provider/UserProvider";


const urlBase = process.env.REACT_APP_BEEDRONE_WEB_API


export const useRoles = () => {

    const { stateUser , signOut } = useContext(UserContext);

    const [ roles, setRoles ] = useState(); 

    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();
    const [ isOpenModal, openModal, closeModal] = useModal();

    
    useEffect(() => {
        listarRoles();
    }, []);


    const listarRoles = async () => {
        mostrarSpinner();
        const response = await Fetch({url :urlBase + '/Role'})

        if (response.isValid) {
            setRoles(response.content)
        } else {
            notify(response.exceptions[0].description,"error")
        }
        ocultarSpinner()
    }

    return {
        roles,
        isOpenModal,
        closeModal,
        spinner,
    };
}